(() => {
  const getDialog = () => document.getElementById('cb-sale-event-dialog');

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cb-sale-open]');
    if (opener) {
      event.preventDefault();
      const dialog = getDialog();
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }

    const closer = event.target.closest('[data-cb-sale-close]');
    if (closer) {
      const dialog = closer.closest('dialog') || getDialog();
      if (dialog?.open && typeof dialog.close === 'function') dialog.close();
      else dialog?.removeAttribute('open');
    }
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement) || dialog.id !== 'cb-sale-event-dialog') return;
    const rect = dialog.getBoundingClientRect();
    const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
    if (!inside) dialog.close();
  });
})();
